import { useState } from "react";
import withDashboardLayout from "../../hoc/withDashboardLayout";
import BroadcastNotification from "../../components/admin/BroadcastNotification";
import { Tabs } from "antd";
// import MaterialTable from 'material-table';
// import tableIcons from '../../utils/tableIcons';
// import { LeftOutlined, RightOutlined } from '@ant-design/icons';
// import CustomSelect from '../../components/ui/CustomSelect';
// import SortIcon from '../../assets/sort.svg';
import EmailNotification from "../../components/admin/notifications/EmailNotification";
import PushNotification from "../../components/admin/notifications/PushNotification";
import EmailTemplates from "../../components/admin/notifications/EmailTemplates";
import PushTemplates from "../../components/admin/notifications/PushTemplates";

const Notifications = () => {
  const [open, setOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("email");

  const tabItems = [
    {
      key: "email",
      label: `Email`,
      children: <EmailNotification activeTab={activeTab} open={open} />,
    },
    {
      key: "push",
      label: `Push`,
      children: <PushNotification activeTab={activeTab} open={open} />,
    },
    {
      key: "emailtemplates",
      label: "Email Templates",
      children: <EmailTemplates />,
    },
    {
      key: "pushtemplates",
      label: "Push Templates",
      children: <PushTemplates />,
    },
  ];

  const onTabChange = (option) => {
    setActiveTab(option);
  };

  return (
    <div className="w-full h-full">
      <div className="w-[95%] mx-auto">
        {/* Notifications Header */}
        <div className="w-full py-4">
          <div className="flex items-center justify-between">
            <h2 className="font-semibold title text-lg text-[#000000]">
              Notifications
            </h2>
            <button
              onClick={() => setOpen(true)}
              className="text-xs px-3 rounded-2xl py-[9px] bg-[#61373f] text-white font-normal"
            >
              Broadcast Notification
            </button>
          </div>
        </div>

        {/* Notifications */}

        {/* <div className='search-custom-space main-scroll w-full min-h-[calc(100vh-181px)] h-[380px] overflow-scroll flex flex-col gap-y-5 box-shadow rounded-2xl relative'>
                    <div className='custom-sortby absolute z-50 left-[284px] top-[19px]'>
                        <CustomSelect prefixIcon={SortIcon} placeholder='Sort by' onChange={(val) => handleSortChange(val)}>
                            <Select.Option value='success'>Success</Select.Option>
                            <Select.Option value='pending'>Pending</Select.Option>
                        </CustomSelect>
                    </div>

                    <MaterialTable
                        title="Clients"
                        columns={columns}
                        icons={tableIcons}
                        options={{
                            showTitle: false,
                            draggable: false,
                            paging: true,
                            pageSize: itemsPerPage,
                            pageSizeOptions: [10, 15, 20],
                            debounceInterval: 700,
                            padding: 'desne',
                            paginationType: 'stepped',
                            searchFieldVariant: 'outlined',
                            searchFieldAlignment: 'left'
                        }}
                        // data={query => fetchData(query)}
                        data={fetchData()}
                        // actions={[
                        //     {
                        //         icon: () =>
                        //             <Select defaultValue="This Month"
                        //                 className='w-40'
                        //                 onChange={handleSelectChange}
                        //                 options={[
                        //                     {
                        //                         value: 'thismonth',
                        //                         label: 'This Month',
                        //                     },
                        //                     {
                        //                         value: 'thisyear',
                        //                         label: 'This Year',
                        //                     },
                        //                     {
                        //                         value: 'lastmonth',
                        //                         label: 'Last Month',
                        //                     },
                        //                     {
                        //                         value: 'lastyear',
                        //                         label: 'Last Month',
                        //                     },
                        //                 ]}
                        //             />,
                        //         isFreeAction: true,
                        //     }
                        // ]}
                        components={{
                            Pagination: (props) => {
                                const { page, rowsPerPage, count, onChangePage, onChangeRowsPerPage } = props;
                                return (
                                    <div className="box-shadow-pagination text-sm" style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px 20px', marginTop: '20px' }}>
                                        <div>
                                            <div className='bottom-pagination-text'>
                                                <button className='disabled:opacity-50' onClick={(e) => onChangePage(e, page - 1)} disabled={page === 0}><LeftOutlined /></button>
                                                <span style={{ margin: '0 10px' }}>{page + 1} of {Math.ceil(count / rowsPerPage)}</span>
                                                <button className='disabled:opacity-50' onClick={(e) => onChangePage(e, page + 1)} disabled={page === Math.ceil(count / rowsPerPage) - 1}><RightOutlined /></button>
                                            </div>
                                        </div>
                                        <div style={{ position: 'absolute', right: '25px' }} >
                                            <span style={{ margin: '0 10px' }}>Items per page:</span>
                                            <select className='pagination-select' value={rowsPerPage} onChange={(e) => {
                                                setItemsPerPage(e.target.value);
                                                onChangeRowsPerPage(e, itemsPerPage)
                                            }}>
                                                <option value={10}>10</option>
                                                <option value={15}>15</option>
                                                <option value={20}>20</option>
                                            </select>
                                        </div>
                                    </div>
                                );
                            },
                            // OverlayLoading: () => <div style={{ height: '100vh', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            //     <h2>Loading....</h2>
                            // </div>
                        }}
                    />
                </div> */}

        <div className="w-full main-scroll min-h-[calc(100vh-176px)] h-[380px] overflow-scroll flex flex-col gap-y-4 box-shadow rounded-2xl pt-5 bg-white">
          <div className="w-full space-tab">
            <Tabs
              defaultActiveKey="email"
              items={tabItems}
              onChange={onTabChange}
            />
          </div>
        </div>
      </div>
      <BroadcastNotification open={open} setOpen={setOpen} />
    </div>
  );
};

export default withDashboardLayout(Notifications);
